
const config = {
    base_path:'/',
    login_uri:'/login/',
    api_uri: "https://jesiapi.jerseyeng.com/api", 
    tokenVar: 'JE5ITO9O12O2EACC355P01N7T0K3N',
    remeber_me_token: 'JE5ITO9O12O2ER3M3M83RM37T0K3N',
};

export default config; 